/*
 Initialize the form validation according to options:

 $form: jQuery object which references to the form.
 items: Each field configuration
 $el: jQuery object which references to the field
 $form: jQuery object which references to the wrapping element of the field
 registered: If it is a email field, set to false to enable check against the existance of membership

 */
define('shared/initializer/form/submissions/OnSite',[
    '$',
    './Base',
    '../constants',
    'shared/lib/ctor',
    'shared/lib/RSVP',
    'shared/lib/Chuanr',
    'shared/lib/validate',
    'shared/lib/JSON3',
    'shared/util/jquery/tooltip',
    'shared/util/hub',
    'shared/util/validate/validators/notRegistered',
    'shared/util/validate/validators/chuanr',
    'shared/util/validate/validators/creditCard',
    'shared/util/validate/validators/creditCardName',
    'shared/util/validate/validators/function',
    'shared/util/validate/validators/phoneRange',
    'shared/util/ValidationBinder',
    'shared/util/dom/form/disable', 
    'shared/util/dom/form/enable',
    'shared/util/fields/Telephone',
    'shared/util/state',
    'shared/lib/console',
    'shared/page/market'
],
function (
    $,
    Base,
    constants,
    ctor,
    RSVP, 
    Chuanr, 
    validate, 
    JSON, 
    Tooltip,
    hub,
    validatorNotRegistered, 
    validatorChuanr, 
    validatorCreditCard, 
    validatorCreditCardName, 
    validatorFunction,
    phoneRange,
    ValidationBinder,
    disableForm, 
    enableForm, 
    TelephoneField,
    state,
    console,
    getMarket
) {
    'use strict';

    var FUNCTION = 'function';

    var $global = $(this);
    var popup;

    function escapeValidationName(input){
        return input.replace(/\./g, '__godblessmartin__');
    }

    function unescapeValidationName(input){
        return input.replace(/__godblessmartin__/g, '.');
    }

    function measureFormLoaded() {
        if (!window.performance || typeof window.performance.measure != 'function') {
            return;
        }

        performance.measure('form.onsite.loaded', 'navigationStart');
    }

    function getTooltipElement( item ){
        if (item.$el.attr('type') == 'checkbox') {
            return item.$el.parent('label');
        }
        else if (item.$el.attr('type') === 'radio') {
            return item.$el.parent();
        }
        else if(item.$el.prop('tagName').toUpperCase() === 'SCRIPT') {
            return item.$wrap.find('>*:visible').eq(0);
        }
        else {
            return item.$el;
        }
    }

    function onSuccess(item) {
        item.pass();
    }

    function onValidationError(item, errs) {

        if (errs [ item.field ] == null) {
            return;
        }

        var errText = errs[ item.field ][0];

        return showValidationError(item, errText);
    }

    function scrollIntoView($target){
        var globalHeight = $global.height();
        var globalWidth = $global.width();
        var targetOffset = $target.offset();
        targetOffset.bottom = targetOffset.top + $target.outerHeight();
        targetOffset.right = targetOffset.left + $target.outerWidth();

        var windowOffset = {
            top: $global.scrollTop(),
            left: $global.scrollLeft()
        };
        windowOffset.bottom = $global.scrollTop() + globalHeight;
        windowOffset.right = $global.scrollLeft() + $global.width();

        // return if they are collided
        if (
            !(
                targetOffset.left > windowOffset.right || 
                targetOffset.right < windowOffset.left ||
                targetOffset.top > windowOffset.bottom ||
                targetOffset.bottom < windowOffset.top 
            )
        ) {
            return;
        }

        $('body').animate({
            scrollTop: $target.offset().top - globalHeight / 2,
            scrollLeft: $target.offset().left - globalWidth / 2
        }, 300);
    }

    function showValidationError(item, errText) {
        item.fail();

        if (popup != null) {
            var existPopupOffset = popup.$el.is(':visible')?popup.$el.offset():popup.$wrap.offset();
            var newOffset = item.$el.is(':visible')?item.$el.offset():item.$wrap.offset();
            if (
                existPopupOffset.top > newOffset.top ||
                (
                    existPopupOffset.top == newOffset.top && 
                    existPopupOffset.left > newOffset.left
                )
            ) {
                if (popup.tooltip) {
                    popup.tooltip.destroy();
                }
            }
            else {
                return;
            }
        }

        var $toolTipElement = getTooltipElement(item);
        var tooltipPlacement = 'auto top';
        if (
            $toolTipElement.hasClass('tooltip-on-right')
        ) {
            if ($toolTipElement.css('direction') === 'rtl') {
                tooltipPlacement = 'auto left';
            }
            else{
                tooltipPlacement = 'auto right';
            }
        }

        if (item.tooltip) {
            item.tooltip.destroy();
        }
        item.tooltip = new Tooltip($toolTipElement[0], {
            placement: tooltipPlacement,
            title: errText,
            html: true,
            trigger: 'manual'
        });
        item.tooltip.show();

        scrollIntoView($toolTipElement);

        popup = item;

        setTimeout(function () {
            $global.one('click', function () {
                if (item.tooltip) {
                    item.tooltip.hide();
                }
                popup = null;
            });
        }, 500);
    }

    function serializeObject($form) {
        var o = {};
        var a = $form.serializeArray();
        $.each(a, function () {
            if (o[this.name] !== undefined) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || '');
            } else {
                o[this.name] = this.value || '';
            }
        });
        return o;
    }

    function extractPatterns(pttns) {
        var patterns = ( pttns || '' ).split('\n');

        for (var l = patterns.length; l--;) {
            if (patterns[l] + '' == false) {
                patterns.splice(l, 1);
            }
        }

        return patterns;
    }

    function createChuanr(item, pttns) {
        var KEY_DATA = 'chuanr.instance';
        var ret;
        var $el = item.$el;

        ret = $el.data(KEY_DATA);

        if (ret instanceof Chuanr) {
            ret.dispose();

            setTimeout(function(){
                item.reset();
                if (item.tooltip) {
                    item.tooltip.destroy();
                }
            });
        }

        ret = new Chuanr({
            always: true
        });

        ret.roast($el[0], pttns);
        ret.on('prevented', function (format) {
            // construct user friendly error message
            var p = Chuanr.setting.Pattern.parse(
                format.pattern.pattern + '{*}'
            );

            for (var i = 0; i < p.items.length; i++) {
                var curItem = p.items[i];
                if (curItem.type == 2) {
                    curItem.param = '';
                    curItem.value = '*';
                }
            }

            var errs = {};
            // remove the leading '^'
            errs[ item.field ] = [ item.message.invalid.replace(/^\^/, '') ];

            onValidationError(item, errs);
        });
        ret.on('resumed', function () {
            item.reset();
        });

        $el.data(KEY_DATA, ret);

        return ret;
    }

    function getErrorMessages(){
        var me = this;
        var messages = {};
        var text;

        for(var key in me.messages) {
            if (!me.messages.hasOwnProperty(key)) {
                continue;
            }

            text = me.messages[key];

            if (text == null || text === '' || text == false) {
                messages[key] = '^Unknown "' + key + '" error ';
            }
            else {
                messages[key] = '^' + text;
            }
        }
     
        return messages;
    }


    function getItemConfig(key, item, $form, items, constraints, userMarket) {
        return {
            $el: item.$el,
            $wrap: item.$wrap,
            pass: item.pass,
            fail: item.fail,
            constraints: constraints,
            setup: function () {
                var me = this, pttns, constraint;
                var $el = me.$el;
                var fieldLower;

                me.message = getErrorMessages.call(item);
                me.hasRequired = $el.attr('required') != null;
                me.field = $el.attr('name');
                me.combinedField = $el.attr('data-combined-field');
                fieldLower =  me.field.toLowerCase();

                pttns = extractPatterns($el.attr('data-validation-pattern'));
                constraint = me.constraints[ me.field ] = {};

                constraint[validatorFunction.KEY] = { 
                    func: function(){
                        if (typeof item.validate === 'function') {
                            return item.validate.apply(item, arguments);
                        }
                        else{
                            return RSVP.resolve();
                        }
                    }
                };

                if ( me.hasRequired ) {
                    constraint.presence = { message: me.message.invalid };
                }
                if ( fieldLower == 'email' ) {
                    constraint.email = { message: me.message.invalid };

                    if (item.registered === false) {
                        constraint[validatorNotRegistered.KEY] = { message: ( me.message.inuse || me.message.invalid ) };
                    }
                }
                if ( fieldLower == 'cardverificationcode' ) {
                    constraint.numericality = { message: me.message.invalid };
                    constraint.length = { message: me.message.invalid, length: { maximum: 4 } };
                }
                if ( fieldLower == 'firstname' || fieldLower == 'lastname' ) {
                    constraint.format = { 
                        pattern: '[a-zA-Z- ]+',
                        message: me.message.invalid 
                    };
                }
                if ( fieldLower == 'creditcardnumber' ) {
                    constraint[validatorCreditCard.KEY] = { message: me.message.invalid };
                }
                if ( fieldLower == 'creditcardname' ) {
                    constraint[validatorCreditCardName.KEY] = { message: me.message.invalid };
                }
                var chuanr;
                function setupConstraint(pttns){
                    if ( pttns.length > 0 ) {
                        chuanr = createChuanr(me, pttns);
                        constraint[validatorChuanr.KEY] = { message: me.message.invalid, chuanr: chuanr };
                        if (fieldLower == 'telephone' || fieldLower == 'mobilephone') {
                            new TelephoneField($el, chuanr).setupChuanrRefresh(
                                function createChuanrDelegate(pttns){
                                    return createChuanr(me, pttns);
                                },
                                function onChuanrRefreshed(chuanr){
                                    constraint[validatorChuanr.KEY].chuanr = chuanr;
                                }
                            );
                        }
                    }
                }

                if (fieldLower == 'telephone' || fieldLower == 'mobilephone') {
                    // telephone field should ignores the pattern applied on field setting if there is 
                    // a global setting, this is to compatibile with the old logic in lpform
                    pttns = TelephoneField.getEtownMarketPhonePatterns(userMarket);
                    setupConstraint(pttns);
                    constraint[phoneRange.KEY] = { message: me.message.invalid };
                }
                else {
                    setupConstraint(pttns);
                }
            },
            reset: function () {
                item.reset();
            },
            validate: function () {
                var me = this;
                return new RSVP.Promise(function (resolve, reject) {
                    var formObject = serializeObject($form);
                    var formFields = {};
                    var constraints = {};
                    var key, newKey;

                    for(key in formObject) {
                        if(me.constraints[key] && !me.constraints[key].presence && formObject[key] === ''){
                            continue;
                        }

                        newKey = escapeValidationName(key);
                        formFields[newKey] = formObject[key];
                    }

                    for(key in me.constraints) {
                        if(formObject[key] === '' && !me.constraints[key].presence){
                            continue;
                        }

                        if(typeof(formObject[key]) == 'undefined' && items.get(key) && items.get(key).$el.is(':disabled')){
                            continue;
                        }

                        newKey = escapeValidationName(key);
                        constraints[newKey] = me.constraints[key];
                    }

                    validate
                        .async(formFields, constraints)
                        .then(resolve, function(reason){
                            if (!(escapeValidationName(me.field) in reason)) {
                                resolve();
                                return;
                            }

                            var realReason = {};
                            for(key in reason) {
                                newKey = unescapeValidationName(key);
                                realReason[newKey] = reason[key];
                            }

                            return reject(realReason);
                        });
                });
            }
        };
    }

    

    var Ctor = ctor(function(){
        var me = this;
        me.base.apply(me, arguments);
        me.errors.on('show', function(error){
            if (error.fatal) {
                disableForm(me.$form);
            }
            else {
                enableForm(me.$form);
            }
            
            if (typeof me.adapter.doError === FUNCTION) {
                me.adapter.doError(error);
            }
        });
        me.handleError = (function handleError(reason) {
            var me = this;
            me.errors.show(reason);
            hub.set(constants.SUBMISSION.HUB_LOAD_FINISHED, true);
            return RSVP.reject(reason);
        }).bind(me);
    }).inherit(Base);

    /*
        Flow:
                   if success
        doPageLoad ----------> doBeforeSubmit   -> doSubmit    ->  doAfterSubmit
        (init data)            (fill form data)    (ajax post)     (redirect)
    */
    Ctor.prototype.init = function init() {
        var me = this;
        var $form = me.$form;
        var adapter;
        var items;
        var curItem;
        var detail = {};
        var constraints = {};
        var promisePageLoad = new RSVP.Promise(function (resolve) {
            resolve();
        });
        // TODO: Telephone field related logic should be moved to mixin
        var market;

        return Base.prototype.init.apply(me, arguments)
            .then(function(){
                return getMarket(true);
            })
            .then(function(marketValue){
                market = marketValue;
            })
            .then(function(){
                adapter = me.adapter;
                items = adapter.items;

                if (typeof adapter.doPageLoad == FUNCTION) {
                    promisePageLoad = adapter.doPageLoad();
                }

                return promisePageLoad
                    .then(null, me.handleError);
            })
            .then(function(){
                var vb = new ValidationBinder();

                for (var key in items) {
                    if (!items.hasOwnProperty(key)) {
                        continue;
                    }

                    curItem = items[key];

                    if (curItem.$el.is('[type=hidden]')) {
                        continue;
                    }

                    detail[key] = getItemConfig(
                        key, 
                        curItem, 
                        $form, 
                        items, 
                        constraints, 
                        market
                    );
                }

                vb.on('beforevalidate', function(dfd){
                    if (adapter.isDisabled) {
                        return;
                    }
                    if (typeof adapter.doBeforeValidation != FUNCTION) {
                        dfd.resolve();
                    }
                    else {
                        dfd.resolve(adapter.doBeforeValidation());
                    }
                });
                vb.on('validationfail', function (dfd) {
                    me.trigger('submit.fail');
                    if (typeof adapter.doValidationFail != FUNCTION) {
                        dfd.resolve();
                    }
                    else {
                        dfd.resolve(adapter.doValidationFail());
                    }
                });
                vb.on('beforesubmit', function (dfd) {

                    promisePageLoad
                        .then(function () {
                            if (typeof adapter.doBeforeSubmit != FUNCTION) {
                                return;
                            }
                            else {
                                return adapter.doBeforeSubmit();
                            }
                        })
                        .then(dfd.resolve, dfd.reject);

                });
                vb.on('submit', function (dfd) {
                    if (typeof adapter.doSubmit != FUNCTION) {
                        dfd.resolve();
                    }
                    else {
                        dfd.resolve(adapter.doSubmit());
                    }
                });
                vb.on('aftersubmit', function (dfd, evt, data) {
                    if (dfd == null) {
                        dfd = RSVP.defer();
                    }

                    if (typeof adapter.doAfterSubmit != FUNCTION) {
                        dfd.resolve();
                    }
                    else {
                        dfd.resolve(adapter.doAfterSubmit(data));
                    }

                });
                vb.on('submitfail', function (reason) {
                    if (typeof adapter.doSubmitFail == FUNCTION) {
                        adapter.doSubmitFail(reason);
                    }

                    // retrigger reject as martin wants it to be shown in console
                    RSVP.reject(reason);

                    if (reason && reason.abort === true) {
                        return;
                    }

                    me.trigger('submit.fail');
                    me.errors.show(reason);
                });
                vb.on('submitsuccess', function () {
                    me.trigger('submit.success');
                });
                vb.setup({
                    $form: $form,
                    options: {
                        onsuccess: onSuccess,
                        onerror: onValidationError
                    },
                    detail: detail
                });
            })
            .then(function(){
                return adapter.doAfterPageLoad()
                    .then(function(){
                        hub.set(constants.SUBMISSION.HUB_LOAD_FINISHED, true);
                        measureFormLoaded();
                    }, me.handleError);
            }, me.handleError);
    };

    return Ctor;

});
